import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { servicios_grupogack_nomina, servicios_grupogack_catalogo, nominas_nominas } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
//import { ArrayJsonTipoDocumentos } from '../../../Helpers/JsonToOneLevel';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const NominasOrganizacion = ({ id, permisos }) => {
    const [ nominas, setNominas ] = useState( null );
    const [ tiposPeriodicidad, setTiposPeriodicidad ] = useState( null );
    const [ origenRecursos, setOrigenRecursos ] = useState( null );
    const [ regimenFiscales, setRegimenFiscales ] = useState( null );
    const [ tiposRegimen, setTiposRegimen ] = useState( null );
    const [ tiposPeriodo, setTiposPeriodo ] = useState( null );
    useEffect(() => {
        axiosNomninas();
        axiosTiposPeriodicidad();
        axiosOrigenRecursos();
        axiosRegimenFiscales();
        axiosTiposRegimen();
        axiosTiposPeriodo();
    }, []);

    const axiosNomninas = () => {
        axios.get( `${servicios_grupogack_nomina}/config/nomina`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        //setTiposDocumentos( ArrayJsonTipoDocumentos( respuesta.data.dataResponse ) );
                        setNominas( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setNominas([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    /* Axios para consumo de servicio TiposPeriodicidad */
    const axiosTiposPeriodicidad = () => {
        axios.get( `${servicios_grupogack_catalogo}/periodicidad`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setTiposPeriodicidad( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setTiposPeriodicidad([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    /* Axios para consumo de servicio OrigenRecursos */
    const axiosOrigenRecursos = () => {
        axios.get( `${servicios_grupogack_catalogo}/origenrecurso/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setOrigenRecursos( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setOrigenRecursos([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    /* Axios para consumo de servicio RegimenFiscal */
    const axiosRegimenFiscales = () => {
        axios.get( `${servicios_grupogack_catalogo}/regfiscal/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setRegimenFiscales( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setRegimenFiscales([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    /* Axios para consumo de servicio TiposRegimen */
    const axiosTiposRegimen = () => {
        axios.get( `${servicios_grupogack_catalogo}/tiporegimen/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setTiposRegimen( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setTiposRegimen([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    /* Axios para consumo de servicio TipoPeriodo */
    const axiosTiposPeriodo = () => {
        axios.get( `${servicios_grupogack_catalogo}s/tipo/periodo/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setTiposPeriodo( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setTiposPeriodo([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { nominas && tiposPeriodicidad && origenRecursos && regimenFiscales && tiposRegimen && tiposPeriodo ?
                <DataTableService id={id} title={ nominas_nominas } permisos={permisos}
                    columns={[
                        { field: "nominaClave", title: "Clave" },
                        { field: "nominaNomCorto", title: "Nombre Corto" },
                        { field: "nominaNombre", title: "Nombre Nómina" },
                        { field: "nominaDescrip", title: "Descripción" },
                    ]}
                    data={ nominas }
                    informacionAdicional={{ tiposPeriodicidad, origenRecursos, regimenFiscales, tiposRegimen, tiposPeriodo }} /> : <SpinnerOval />
            }
        </div>
    );
}
 
export default NominasOrganizacion;